import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import DashLayout from "@/components/DashLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "@/components/ui/table";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const empty = { title: "", description: "", location: "", event_date: "", cover_image: "" };

export default function SuperEvents() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [f, setF] = useState(empty);

  const load = async () => { const { data } = await api.get("/events"); setItems(data); };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/events", f); toast.success("Created"); setOpen(false); setF(empty); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const remove = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/events/${id}`); load(); };

  return (
    <DashLayout variant="super" title="Events">
      <div className="flex justify-between mb-6">
        <div className="text-sm text-slate-500">{items.length} events</div>
        <Button onClick={() => setOpen(true)} className="bg-slate-900 hover:bg-slate-800" data-testid="new-event-btn"><Plus className="w-4 h-4 mr-2" />New Event</Button>
      </div>
      <div className="bg-white rounded-lg border border-slate-200">
        <Table>
          <TableHeader><TableRow><TableHead>Title</TableHead><TableHead>Date</TableHead><TableHead>Location</TableHead><TableHead className="text-right">Actions</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((e) => (
              <TableRow key={e.id} data-testid={`row-event-${e.id}`}>
                <TableCell className="font-semibold">{e.title}</TableCell>
                <TableCell>{e.event_date}</TableCell>
                <TableCell>{e.location}</TableCell>
                <TableCell className="text-right"><Button size="sm" variant="ghost" onClick={() => remove(e.id)} data-testid={`delete-event-${e.id}`}><Trash2 className="w-4 h-4 text-red-600" /></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent><DialogHeader><DialogTitle>New Event</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-4" data-testid="event-form">
            <div><Label className="mb-1 block">Title *</Label><Input required value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} data-testid="ef-title" /></div>
            <div><Label className="mb-1 block">Date *</Label><Input type="date" required value={f.event_date} onChange={(e) => setF({ ...f, event_date: e.target.value })} data-testid="ef-date" /></div>
            <div><Label className="mb-1 block">Location</Label><Input value={f.location} onChange={(e) => setF({ ...f, location: e.target.value })} data-testid="ef-location" /></div>
            <div><Label className="mb-1 block">Cover Image URL</Label><Input value={f.cover_image} onChange={(e) => setF({ ...f, cover_image: e.target.value })} data-testid="ef-cover" /></div>
            <div><Label className="mb-1 block">Description</Label><Textarea rows={4} value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} data-testid="ef-description" /></div>
            <DialogFooter><Button type="submit" className="bg-slate-900 hover:bg-slate-800" data-testid="ef-submit">Create</Button></DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </DashLayout>
  );
}
